import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import ReferrerModal from '../../containers/ReferrerModal/ReferrerModal';
import { StateType } from '../../reducers';
import { logoutCompetitionIdSelector } from '../../reducers/CompetitionsReducer/CompetitionsSelector';
import HOCAgreementsValidation from '../HOCAgreementsValidation/HOCAgreementsValidation';

const PrivateRoute = ({ component: Component, isAuthenticated, needsRecertification, ...rest }: any) => {
  const routeComponent = (props: any) => {
    const pathnameToRedirect = rest.logoutCompetition ? `/sign-in/${rest.logoutCompetition}` : '/sign-in';

    return needsRecertification ? (
      <Redirect to={{ pathname: '/recertification', state: { from: props.location } }} />
    ) : isAuthenticated ? (
      <Component {...props} />
    ) : (
      <Redirect to={{ pathname: pathnameToRedirect, state: { from: props.location } }} />
    );
  };

  return <Route {...rest} render={routeComponent} />;
};

interface RouteComponentStateProps {
  logoutCompetition: string;
}

const mapStateToProps = (state: StateType): RouteComponentStateProps => ({
  // @ts-ignore
  logoutCompetition: logoutCompetitionIdSelector(state),
});

export default ReferrerModal(
  HOCAgreementsValidation(connect<RouteComponentStateProps, any, any, StateType>(mapStateToProps)(PrivateRoute))
);
